// extracted by mini-css-extract-plugin
export var checkbox = "_81-0";
export var circle = "_81-3";
export var horizontalContainer = "_81-7";
export var sm = "_81-5";
export var switch0 = "_81-2";
export var switchDisabled = "_81-8";
export var switchEnabled = "_81-1";
export var textSwitchContainer = "_81-9";
export var textSwitchOption = "_81-a";
export var textSwitchOptionSelected = "_81-b";
export var verticalContainer = "_81-6";
export var xs = "_81-4";